import cn from "classnames";
import { Button } from "../../../button";
import { useMediaQuery } from "../../../grid";
import { DialogButtonProps } from "./types";
import styles from "./styles.module.scss";

export const DialogButton = ({
  children,
  className,
  fullscreen,
  dataTestId,
  onClick,
}: DialogButtonProps) => {
  const isMobile = useMediaQuery("xxs");

  return (
    <Button
      type={fullscreen ? "circle" : "icon"}
      htmlType="button"
      className={cn(className, { [styles.button]: fullscreen && isMobile })}
      onClick={onClick}
      dataTestId={dataTestId}
    >
      {children}
    </Button>
  );
};
